export const bugoTermsList = ['별세', '소천', '영면', '선종', '운명', '열반', '타계', '서거'];

export const deathCharactor = '故';
